export default __webpack_public_path__ + "static/media/Tick-large.46b9903c.svg";